import { type Actions, ActionType } from './application-modules.actions';
import { applicationModuleAdapter, initialState, type State } from './application-modules.state';

export function applicationModulesReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.FETCH_APPLICATION_MODULES: {
            return {
                ...state,
                isPending: true
            };
        }

        case ActionType.FETCH_APPLICATION_MODULES_SUCCEEDED: {
            return applicationModuleAdapter.setAll(action.payload.applicationModules, {
                ...state,
                isLoaded: true,
                isPending: false
            });
        }

        case ActionType.FETCH_APPLICATION_MODULES_FAILED: {
            return {
                ...state,
                isLoaded: false,
                isPending: false
            };
        }

        case ActionType.RESET: {
            return { ...initialState };
        }

        default:
            return state;
    }
}
